import { render, staticRenderFns } from "./SummaryTotal.vue?vue&type=template&id=e4bcf0ac"
import script from "./SummaryTotal.vue?vue&type=script&lang=js"
export * from "./SummaryTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports